import { Alert, Box, Button, DialogActions, DialogContent, Divider, Grid, TextField, CircularProgress } from '@mui/material'
import React, { useState } from 'react'
import { BootstrapDialog, BootstrapDialogTitle } from '../../../assets/theme/theme'
import styles from '../../resource-request/ResourceRequestsCommentPopup/ResourceRequestsCommentPopup.module.scss'
import { makeStyles } from '@mui/styles'
import moment from 'moment'
import { DATE_FORMAT_2, TIME_FORMAT } from '../../../utilities/constants'
import { AlertDto } from '../../../utilities/models'

const useStyles = makeStyles(() => ({
  textarea: {
    resize: 'vertical'
  }
}))

const ResourceRequestsCommentPopup: React.FC<{
  addResourceComment(text: string, requestId: number, resourceId: number): void;
  isCommentPopupOpen: boolean
  resourceId: number
  setIsCommentPopupOpen(args: boolean): void
  resourceRequestId: number
  getAllComments(requestId: number, resourceId: number): void
  commentList: any
  commentListIsLoading: any
  addResourceCommentAlert: AlertDto
  clearAddCommentAlert(): void
  addResourceCommentIsLoading: boolean
}> = (props) => {
  const classes = useStyles()
  const [text, setText] = useState('')

  const onInputHandleCommentFormChange = (property: string, value: any) => {
    setText(value)
  }

  const addComment = () => {
    props.addResourceComment(text, props.resourceRequestId, props.resourceId)
  }

  React.useEffect(() => {
    if (props.addResourceCommentAlert?.severity === 'success') {
      props.getAllComments(props.resourceRequestId, props.resourceId)
    }
  }, [props.addResourceCommentAlert])

  React.useEffect(() => {
    props.getAllComments(props.resourceRequestId, props.resourceId)
  }, [props.commentList?.length >= 0])

  return (
    < BootstrapDialog
      className={styles.dialog}
      aria-labelledby="customized-dialog-title"
      open={props.isCommentPopupOpen} >
      <BootstrapDialogTitle id="customized-dialog-title"
        onClose={() => {
          setText('')
          props.setIsCommentPopupOpen(false)
        }}>
        <strong>Comments</strong><br></br>
        <div className={styles.dialogHeading}>
        </div>
        <Divider></Divider>
      </BootstrapDialogTitle>
      <DialogContent className={styles.dialogContent}>
      {props.addResourceCommentAlert?.message && (
              <Alert
                className="mb-m"
                onClose={props.clearAddCommentAlert}
              >
                {props.addResourceCommentAlert.message}
              </Alert>
      )}
        <Grid container spacing={2} >
          <Grid item lg={12}>
            <TextField
              variant='outlined'
              minRows={3}
              label="Type your comment here..."
              fullWidth
              multiline
              style={{ width: 550 }}
              value={text}
              required={true}
              onChange={(event) => onInputHandleCommentFormChange('comment', event.target.value)}
              inputProps={{ className: classes.textarea }}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions className={styles.cardActionStyle}>
        <Button
          variant="contained"
          className={'btnStyle'}
          onClick={() => {
            setText('')
            addComment()
          }}>
          {(props.addResourceCommentIsLoading) && (
            <CircularProgress size="12px" className={styles.loading} />
          )}
          Add
        </Button>
      </DialogActions>
      <Box style={{ overflow: 'auto' }}>
        <DialogContent className={styles.dataContent} >
          {(props.commentListIsLoading) &&
            <React.Fragment >
              <Alert style={{ paddingRight: '7px', paddingBottom: '16px', justifyContent: 'left' }} severity="info"
                iconMapping={{
                  info: <CircularProgress size={20} />
                }}
              > Loading...</Alert>
            </React.Fragment>
          }

          {(props.commentList?.length === 0 && !props.commentListIsLoading) &&
            <Alert style={{ justifyContent: 'left', paddingBottom: '16px' }} severity="info">No Comments Found!</Alert>
          }

          {(props.commentList?.length > 0 && !props.commentListIsLoading) && (
            props.commentList).map((row: any, index: any) => (
              <React.Fragment key={index}>
                <Grid container spacing={2}>
                  <Grid item lg={1} md={1} xs={1} alignItems="right" className={styles.infoCircleGrid}>
                    <span
                      className={styles.infoCircle + ' layout-row layout-align-center center'}
                    >
                      <sup>{row.createdBy.charAt(0)}</sup>
                    </span>
                  </Grid>
                  <Grid item lg={11} md={11} xs={11} sm container>
                    <Grid item xs container direction="row" spacing={2}>
                      <Grid item lg={9} md={9} xs={9}>
                        <strong>{row.createdBy}</strong>
                      </Grid>
                      <Grid item lg={3} md={3} xs={3}>
                        <span className={styles.date} style={{ textAlign: 'right' }}>{moment(row.createdAt).format(DATE_FORMAT_2)} .&nbsp; {moment(row.createdAt).format(TIME_FORMAT)}</span>
                      </Grid>
                    </Grid>
                    <Grid item lg={12} md={12} xs={12} className={styles.comment}>
                      {row.comment.toString().length > 120
                        ? <p className={styles.comment}>
                          {row.comment.toString().substring(0, 120)}
                        </p>
                        : <p>{row.comment}</p>
                      }
                    </Grid>
                  </Grid>
                </Grid>
                <Divider className={styles.divider}></Divider>
              </React.Fragment>
          ))}

        </DialogContent>
      </Box>
    </BootstrapDialog >
  )
}

export default ResourceRequestsCommentPopup
